import React from "react";
import { useRef } from "react";

import "./Services.css";
import { useState } from "react";
import CompanyLogo1 from "../../assets/images/AgHub.webp";
import CompanyLogo2 from "../../assets/images/balavikas.png";
import CompanyLogo3 from "../../assets/images/carechauwklogo.png";
import CompanyLogo4 from "../../assets/images/hihindiaChauwklogo.png";
import CompanyLogo5 from "../../assets/images/Nsti.jpg";
import CompanyLogo6 from "../../assets/images/ekalavyaChauwklogo.png";
import CompanyLogo7 from "../../assets/images/thub.webp";
import CompanyLogo8 from "../../assets/images/tataStriveChauwklogo.png";
import TechWaves from "../../assets/images/tech-waves.png";
import AIBotImage from "../../assets/images/ai-bot.jpeg";


import Marquee from "react-fast-marquee";
import HeroSection from "../../components/HeroSection/HeroSection";
import servicesPageBg from "../../assets/images/contactus.jpeg";
import WorkingGirl from "../../assets/images/workinggirl.jpg";
import BlogsTestimonial from "../../components/Blogs/blogs";
import Footer from "../../components/Footer";

import {
  FaHandsHelping,
  FaDonate,
  FaPhoneVolume,
  FaUsers,
} from "react-icons/fa";
import businessman from "../../assets/images/businessman.png";
import hiring from "../../assets/images/hiring.png";
import cioCto from "../../assets/images/cio-cto.png";
import admin from "../../assets/images/admin.webp";

import VolunteerForm from "../../components/VolunterrForm/VolunteerForm";
import expandReachImage from "../../assets/images/expand-reach.png";
import earning from "../../assets/images/earning.png";

import skillDevImage from "../../assets/images/skill-dev.avif";
import enterprisePlatform from "../../assets/images/enterprise-platform.jpg";

import dedicated from "../../assets/images/dedicated.jpg";
import dedicatedImageTwo from "../../assets/images/dedicated-image.jpg";
import { MdOutlineSlowMotionVideo } from "react-icons/md";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick"; // Make sure this is imported

import skillTraininer from "../../assets/images/skill-traininer.jpg";
import { motion } from "framer-motion";
import whatWeDoImageBox from "../../assets/images/what-we-do-image.jpeg";
import { IoRocket } from "react-icons/io5";
import { HiMiniSquaresPlus } from "react-icons/hi2";
import { FaPaperPlane } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useEffect } from "react";
import brushImage from "../../assets/images/brush-image.jpg";

import OfferImageFarmer from "../../assets/images/offer-image-1.png";
import OfferEnterprise from "../../assets/images/enterprise-services.jpg";

import OfferImageCarpenter from "../../assets/images/offer-image-2.jpg";

import OfferImageMechanic from "../../assets/images/offer-image-3.jpg";
import OfferImageChef from "../../assets/images/offer-image-4.jpg";
import OfferImageDriver from "../../assets/images/offer-image-5.jpg";
import OfferImageGardener from "../../assets/images/offer-image-6.jpg";
import OfferImageArchitect from "../../assets/images/offer-image-7.jpg";
import OfferImageFisherMan from "../../assets/images/offer-image-8.jpg";
import OfferImageElectrician from "../../assets/images/offer-image-9.jpg";
import OfferImageGuard from "../../assets/images/offer-image-10.jpg";
import OfferImageDomesticHelp from "../../assets/images/offer-image-11.jpg";
import OfferImagePlumber from "../../assets/images/aiplumber.png";
import aiplumber from "../../assets/images/aiplumber.png";
import ElectricianAi from "../../assets/images/ElectricianAi.png";
import GeminiImage4 from "../../assets/images/Gemini_Generated_Image_4.png";
import aiCarpenter from "../../assets/images/aiCarpenter.png";
import skillIcon from "../../assets/images/skill.png"; // Import the skill image

import ProfileIcon from "../../assets/images/check.png"; // Import the skill image
import CommunityIcon from "../../assets/images/care.png"; // Import the skill image

import JobIcon from "../../assets/images/robot.png"; // Import the skill image

import CupIcon from "../../assets/images/cup.png"; // Import the skill image
import { IoIosArrowRoundForward } from "react-icons/io";
import trainer from "../../assets/images/trainer.png";

import Srvicestestimonial from "../../components/ServicesTestimonial/Srvicestestimonial";

import BookDemo from "../../components/BookDemo/BookDemo";

// New Blog Images
import BlogImg1 from "../../assets/images/Gemini_Generated_Image_2.png";
import BlogImg2 from "../../assets/images/Gemini_Generated_Image_3.png";
import BlogImg3 from "../../assets/images/gpthoggpthoggpth.png";

const Services = () => {

const videoRef = useRef(null);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const iframe = videoRef.current;
          if (iframe) {
            iframe.src =
              "https://www.instagram.com/reel/DQuT8zXiGC2/embed?autoplay=1";
          }
        }
      });
    },
    { threshold: 0.5 }
  );

  if (videoRef.current) {
    observer.observe(videoRef.current);
  }

  return () => observer.disconnect();
}, []);










  const [showModal, setShowModal] = useState(false);
  const companyLogos = [
    CompanyLogo1,
    CompanyLogo2,
    CompanyLogo3,
    CompanyLogo4,
    CompanyLogo5,
    CompanyLogo6,
    CompanyLogo7,
    CompanyLogo8,
  ];
  const [showVolunteerForm, setShowVolunteerForm] = useState(false);
  useEffect(() => {
    const btn = document.getElementById("instaPlayPause");
    if (!btn) return;

    let playing = false;
    btn.addEventListener("click", () => {
      playing = !playing;
      btn.textContent = playing ? "⏸" : "▶";
    });

    return () => btn.removeEventListener("click", () => {});
  }, []);
  return (
    <div className="services-container">
      <div className="hero-section">
        <HeroSection
          cName="services-hero-section"
          title="Services"
          text="Empowering Communities, Building Futures"
          heroImg={servicesPageBg}
          // buttonText="Explore More"
          url="/services"
          // btnClass="show"
        />
      </div>
      <div className="our-services-title">OUR SERVICES</div>
      <div className="our-services-title-para">
        At Chauwk, we combine AI-powered enterprise solutions with workforce
        enablement initiatives to help businesses and individuals thrive in a
        rapidly evolving digital economy. From multilingual AI voice agents for
        customer service, sales, and business communication to skilling,
        workforce engagement, and access to essential support services, our
        solutions are designed to enhance operational efficiency, improve
        productivity, create meaningful opportunities, and drive sustainable
        growth for enterprises and communities alike.
      </div>
      <div className="our-services-4-boxes">
        <div className="service-box-atTop">
          <img
            src={AIBotImage} // Using the imported image
            alt="AI Voice Agents"
            className="service-image"
          />{" "}
          <h4 className="service-heading-atTop">AI Voice Agents</h4>
          <p className="service-description-atTop">Available 24/7</p>
        </div>
        <div className="service-box-atTop">

          <img
            src={skillDevImage} // Using the imported image
            alt="Skill Development"
            className="service-image"
          />{" "}
          <h4 className="service-heading-atTop">AI Powered App </h4>
          <p className="service-description-atTop">Human Centric approach</p>
        </div>

        <div className="service-box-atTop">
          <img
            src={enterprisePlatform} // Using the imported image
            alt="Skill Development"
            className="service-image"
          />{" "}
          <h4 className="service-heading-atTop">No Code Platform</h4>
          <p className="service-description-atTop">
            Professional solutions for industry{" "}
          </p>
        </div>

        <div className="service-box-atTop-changed">
          <img
            src={skillTraininer} // Using the imported image
            alt="Skill Development"
            className="service-image-changed"
          />{" "}
          <h4 className="service-heading-atTop-changed">Partner Network </h4>
          <p className="service-description-atTop-changed">
            Last Mile, field expertise
          </p>
        </div>
      </div>
      <div className="our-services-title-wrapper text-center bg-emerald-950 py-24 px-4">
       
      </div>{" "}
      <div className="what-we-do-content">
       
      </div>
      <div className="helped-container">
        <motion.div
          className="helped-container-left"
          whileInView={{ x: 0, opacity: 1 }}
          initial={{ x: -100, opacity: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }} // Triggers when 30% is in view
        >
          
        </motion.div>

        <motion.div
          className="helped-container-right"
          whileInView={{ x: 0, opacity: 1 }}
          initial={{ x: 100, opacity: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }} // Triggers when 30% is in view
        >
          

          <ul className="helped-bullets">
            <li style={{ marginLeft: "-50px" }}>
              {/* <span className="bullet-icon">✔</span> Comprehensive Skill
              Development */}
            </li>
            {/* <li style={{ marginLeft: "-50px" }}>
              <span className="bullet-icon">✔</span> Business Growth & Expansion
            </li> */}
          </ul>

          {/* Icons Section */}
          <div className="helped-icons">
            <div className="helped-icon-item-1">
              {/* <HiMiniSquaresPlus
                className="icon"
                style={{ color: "#024b7c" }}
              /> */}
              {/* <span>Unlock Opportunities</span> */}
            </div>
            <div className="helped-icon-item">
              {/* <IoRocket className="icon" style={{ color: "#024b7c" }} /> */}
              {/* <span>Drive Innovation</span> */}
            </div>
          </div>
        </motion.div>
      </div>
      <div className="news-letter-container">
        <div className="news-letter-content">
          {/* Heading & Subtext */}
          <h2
            className="news-letter-heading"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              color: "white",
              fontSize: "28px",
              fontWeight: "bold",
            }}
          >
            <MdEmail style={{ fontSize: "32px", color: "white" }} />
            Join Our Newsletter
          </h2>
          <p className="news-letter-subtext">
            Stay updated with the latest news, offers, and insights from our
            company.
          </p>

          {/* Email Input Section */}
          <div className="news-letter-input-box">
            <input
              type="email"
              placeholder="Enter your email"
              className="news-letter-input"
            />
            <button className="news-letter-button">
              Subscribe <FaPaperPlane />
            </button>
          </div>
        </div>
      </div>{" "}
      {/* <div>
        <motion.h3
          className="text-5xl text-yellow-50 new-heading-class" // New class name
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          WHAT WE OFFER
        </motion.h3>
      </div> */}
      <div className="what-we-offer-para">
        {/* <p>
          {" "}
          Chauwk is a platform where creativity meets technology, enabling
          artists to shine. We provide seamless solutions for showcasing,
          selling, and discovering unique Join us in redefining the way art is
          experienced and appreciated worldwide.
        </p> */}
      </div>
      <div className="how-can-we-help">
        <div className="ofer-image-1">
          <img src={GeminiImage4} alt="Image_pic" />
        </div>{" "}
        <div className="offer-image-2">
          <img src={OfferImageCarpenter} alt="Image_pic" />
        </div>
        <div className="offer-image-3">
          <img src={OfferImageMechanic} alt="Image_pic" />
        </div>
        <div className="offer-image-4">
          <img src={OfferImageChef} alt="Image_pic" />
        </div>
        <div className="offer-image-5">
          <img src={OfferImageDriver} alt="Image_pic" />
        </div>
        <div className="offer-image-6">
          <img src={ElectricianAi} alt="Image_pic" />
        </div>
        <div className="offer-image-7">
          <img src={aiCarpenter} alt="Image_pic" />
        </div>
        <div className="offer-image-8">
          <img src={OfferImageFisherMan} alt="Image_pic" />
        </div>
        <div className="offer-image-9">
          <img src={OfferImageElectrician} alt="Image_pic" />
        </div>
        <div className="offer-image-10">
          <img src={OfferImageGuard} alt="Image_pic" />
        </div>
        <div className="offer-image-11">
          <img src={OfferImageDomesticHelp} alt="Image_pic" />
        </div>
        <div className="offer-image-12">
          <img src={aiplumber} alt="Image_pic" />
        </div>
        <div className="trusted">
          <h3>
            Trusted by Enterprises & <br /> Workforce Ecosystems
          </h3>
          <p>
            Building intelligent bridges between enterprises, customers, and
            skilled professionals through AI-powered communication, workforce
            engagement, and digital solutions that drive trust, efficiency,
            growth, and long-term impact.
          </p>
          {/* <button className="see-more-button">See More Categories</button> */}
        </div>
      </div>
      <div className="Skilled-Workers-section">
        


        <div className="enterprise-offer-section">
          {/* Left tech waves */}
          <img src={TechWaves} alt="Tech waves" className="tech-waves left" />

          {/* Center heading */}
          <motion.h3
            className="enterprise-animated-heading"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeInOut" }}
          >
            Platform For Enterprise
          </motion.h3>

          {/* Right tech waves */}
          <img src={TechWaves} alt="Tech waves" className="tech-waves right" />
        </div>
        <div className="enterprisepage-offer-section-para">
          <p>
            CHAUWK empowers enterprises to make their frontline and customer
            support more effective. It speeds up readiness and reduces hiring
            and attrition issues through AI led automation, gamification and
            data-driven insights - driving growth and innovation on a unified
            platform.{" "}
          </p>
        </div>

        <div className="enterprise-Two-section">
          {/* Left Side: Text */}
          <div className="enterprise-content">
            <h2 className="enterprise-heading">Enhance Your Enterprise</h2>
            <p className="enterprise-description">
              Empower your team with cutting-edge tools, in-depth analytics and
              AI-driven insights to maximize efficiency, optimize
              decision-making, and accelerate enterprise growth.
            </p>

            <ul className="enterprise-list">
              <li>Quick roll-out with No Code Platform</li>
              <li>Manages high call volumes with 24*7 availability</li>
              <li>Productive customer and employee engagement</li>
              <li>Offers enterprise grade frontline management solutions</li>
              <li>High on Security, Privacy and Compliance</li>
            </ul>
          </div>
          

          {/* Right Side: Instagram Video */}
          <div className="enterprise-insta-video">
            <div className="insta-container">
              <iframe
                ref={videoRef}
                src="https://www.instagram.com/reel/DQuT8zXiGC2/embed"
                title="Enterprise Reel"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                allowFullScreen
                scrolling="no"
              ></iframe>
            </div>
          </div>
        </div>
        <motion.h3
          className="skilled-workers-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          Opportunities for Skilled Workers
        </motion.h3>
        <p className="skilled-workers-para">
          We provide skilled workers with learning resources, career-building
          tools, and job opportunities. Enhance your skills, showcase expertise,
          and connect with industry professionals for better growth.
        </p>
        <div className="services-grid">
          <div className="row">
            <div className="service-box">
              <div className="service-content">
                <img src={skillIcon} alt="Skill Icon" className="service-icon" />
                <div className="service-text">
                  <span>Teach New skills</span>
                  <p>
                    Upskill frontliners and elevate your organization with every
                    step Remove resume Building.
                  </p>
                </div>
              </div>
            </div>

            <div className="service-box">
              <div className="service-content">
                <img
                  src={ProfileIcon}
                  alt="Skill Icon"
                  className="service-icon"
                />
                <div className="service-text">
                  <span> Connect 24*7 </span>
                  <p>
                    Answer customer and employee queries with AI powered chatbot
                    and Voice Agent.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row-2">
            <div className="service-box">
              <div className="service-content">
                <img src={JobIcon} alt="Skill Icon" className="service-icon" />

                <div className="service-text">
                  <span>Hire Smartly </span>
                  <p>
                    Post frontline jobs to instantly get candidate
                    recommendations from a rich pool of talent.
                  </p>
                </div>
              </div>
            </div>
            <div className="service-box">
              <div className="service-content">
                <img
                  src={CommunityIcon}
                  alt="Skill Icon"
                  className="service-icon"
                />
                <div className="service-text">
                  <span>Improve Loyalty </span>
                  <p>
                    Offer a bouquet of services to reduce frontline attrition
                    and improve productivity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h3 className="volunteers-heading">Our Volunteers</h3>
        <p className="volunteers-para" style={{ color: "#4e4d4d" }}>
          Chauwk's volunteers are dedicated individuals committed to making a
          positive impact. They contribute their time and skills to support
          various initiatives, fostering community engagement and meaningful
          change.
        </p>

        <div
          className="volunteer-button"
          onClick={() => setShowVolunteerForm(true)}
          style={{ cursor: "pointer" }}
        >
          Become volunteer
        </div>
        {showVolunteerForm && (
          <VolunteerForm onClose={() => setShowVolunteerForm(false)} />
        )}
      </div>
      <div className="get-involved">
        <div className="partners-section-wrapper text-center bg-emerald-950 py-32 px-4">
          <motion.h3
            className="partner-animation-heading text-5xl text-yellow-50"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeInOut" }}
          >
            We Work with the Best !
          </motion.h3>
        </div>
        <p className="our-partners-description">
          Chauwk has established strong partnerships with top industry leaders,
          working together to foster innovation, create meaningful
          opportunities, and deliver impactful solutions that drive success and
          growth.
        </p>
        <div className="partners-marquee-container">
          <Marquee
            className="partners-marquee"
            speed={50}
            gradient={false}
            autoFill={true}
          >
            {companyLogos.map((logo, index) => (
              <img
                src={logo}
                alt={`Company Logo ${index + 1}`}
                className="company-logo"
                key={index}
              />
            ))}
          </Marquee>
          <Marquee
            className="partners-marquee"
            speed={40}
            gradient={false}
            direction="right"
            autoFill={true}
          >
            {companyLogos.map((logo, index) => (
              <img
                src={logo}
                alt={`Company Logo ${index + 1}`}
                className="company-logo"
                key={index}
              />
            ))}
          </Marquee>
        </div>
      </div>
      <div className="expand-reach text-center bg-emerald-950 py-24 px-4">
        {/* Animated Heading */}
        <motion.h3
          className="expand-reach-animation text-5xl text-yellow-50"
          initial={{ opacity: 0, y: 30 }} // Start position (hidden, moved down)
          whileInView={{ opacity: 1, y: 0 }} // End position (visible, no shift)
          transition={{ duration: 1, ease: "easeInOut" }} // Smooth transition
        >
          EXPAND YOUR REACH
        </motion.h3>
        <p className="expand-reach-description-1">
          Expand your reach and connect with a broader audience effortlessly.
          Leverage cutting-edge digital solutions to grow your network, engage
          with new opportunities, enhance collaboration, and create a lasting
          impact in your industry.
        </p>

        <div className="expand-wrapper">
          {/* Left Side - Image Section */}
          <div className="expand-image-box" style={{ marginLeft: "-20px" }}>
            <img
              src={expandReachImage}
              alt="Expand Reach"
              className="expand-image"
            />
          </div>

          {/* Right Side - Expand Container */}
          <div className="expand-container">
            <div className="expand-row" style={{ marginTop: "-60px" }}>
              {/* <div className="expand-icon-circle"></div> */}

<img 
  src={cioCto} 
  alt="CIO / CTO Icon" 
  className="expand-icon additional-style-class" 
/>

              <div className="expand-small-box expand-box-two">
                <h4>CIO / CTO</h4>
                <p style={{ fontSize: "16px" }}>
                 Chauwk can instantly launch AI voice Agents for your business.
                  <br />
                  <button
                    className="join-here-btn"
                    onClick={() =>
                      (window.location.href =
                        "https://www.enterprise.chauwk.com/register")
                    }
                  >
                    Join Here
                  </button>
                  <IoIosArrowRoundForward className="expand-arrow-icon" />
                </p>
              </div>

              {/* <div
                className="expand-icon-circle-2"
                onClick={() =>
                  (window.location.href =
                    "https://www.enterprise.chauwk.com/register")
                }
              ></div> */}

              <img
                src={businessman}
                alt="Hiring Icon"
                className="expand-icon-2"
              />

              <div className="expand-small-box expand-box-three">
                <h4>Sellers</h4>
                <p style={{ fontSize: "16px" }}>
                  Individuals can showcase and sell products as enterprise
                  sellers.
                  <br />
                  <button
                    className="join-here-btn"
                    onClick={() =>
                      (window.location.href =
                        "https://www.enterprise.chauwk.com/register")
                    }
                  >
                    Join Here
                  </button>
                  <IoIosArrowRoundForward className="expand-arrow-icon" />
                </p>
              </div>
            </div>

            <div className="expand-row" style={{ marginTop: "30px" }}>
              {/* <div className="expand-icon-circle-3"></div> */}

              <img src={admin} alt="Hiring Icon" className="expand-icon-3" />

              <div className="expand-small-box expand-box-five">
                <h4>Trainers</h4>
                <p style={{ fontSize: "16px" }}>
                  Trainers can use Chauwk as a platform to share expertise.
                  &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                  &nbsp;&nbsp; &nbsp;&nbsp;
                  <button
                    className="join-here-btn"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      (window.location.href =
                        "https://www.enterprise.chauwk.com/register")
                    }
                  >
                    Join Here
                  </button>
                  <IoIosArrowRoundForward className="expand-arrow-icon" />
                </p>
              </div>

              <img src={trainer} alt="Hiring Icon" className="expand-icon-4" />
              {/* <div className="expand-icon-circle-4"></div> */}

              <div className="expand-small-box expand-box-six">
                <h4>HR/Admin </h4>
                <p style={{ fontSize: "16px" }}>
                  HR department can use CHAUWK to manage frontline talent.
                  <br />
                  <button
                    className="join-here-btn"
                    onClick={() =>
                      (window.location.href =
                        "https://www.enterprise.chauwk.com/register")
                    }
                  >
                    Join Here
                  </button>
                  <IoIosArrowRoundForward className="expand-arrow-icon" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h4 className="blogs">OUR CUSTOMERS</h4>
      <Srvicestestimonial />

      {/* Blogs & Articles Section */}
      <div className="blogs-articles-section">
        <div className="blogs-articles-header">
          <h2 className="blogs-articles-title">Blogs & Articles</h2>
         
        </div>

        <div className="blogs-grid">
          <div
            className="blog-card"
            onClick={() =>
              window.open(
                "https://blakeoprw840162.bloginwi.com/74223650/chauwk-in-india-transforming-customer-communication-with-ai-voice-technology",
                "_blank"
              )
            }
          >
            <div className="blog-image-wrapper">
              <img src={BlogImg1} alt="Voice AI" className="blog-image" />
            </div>
            <div className="blog-content">
              <span className="blog-category">Technology</span>
              <h3 className="blog-title">
                Why Businesses Are Turning to Voice AI
              </h3>
              <p className="blog-description">
                From instant responses to personalized interactions, see how
                Chauwk is redefining customer communication in India.
              </p>
            </div>
          </div>

          <div
            className="blog-card"
            onClick={() =>
              window.open(
                "https://nanawppr098624.life3dblog.com/39004736/chauwk-in-india-transforming-customer-communication-with-ai-voice-technology",
                "_blank"
              )
            }
          >
            <div className="blog-image-wrapper">
              <img
                src={BlogImg2}
                alt="Customer Experience"
                className="blog-image"
              />
            </div>
            <div className="blog-content">
              <span className="blog-category">Business</span>
              <h3 className="blog-title">
                Smarter Calls. Better Customer Experience.
              </h3>
              <p className="blog-description">
                Chauwk’s AI voice technology is making business communication
                more efficient, scalable, and human-like.
              </p>
            </div>
          </div>

          <div
            className="blog-card"
            onClick={() =>
              window.open(
                "https://marvinoneb885587.aioblogs.com/93180763/chauwk-in-india-transforming-customer-communication-with-ai-voice-technology",
                "_blank"
              )
            }
          >
            <div className="blog-image-wrapper">
              <img
                src={BlogImg3}
                alt="Customer Support"
                className="blog-image"
              />
            </div>
            <div className="blog-content">
              <span className="blog-category">Finance</span>
              <h3 className="blog-title">
                AI Voice is Changing Customer Support
              </h3>
              <p className="blog-description">
                Discover how Chauwk is helping businesses automate
                conversations and create faster customer experiences with voice
                AI.
              </p>
            </div>
          </div>
        </div>
      </div>

      <h4 className="blogs">MEDIA MENTIONS </h4>
      <p className="blogs-para">
        Stay updated with the latest insights, trends, and innovations in the
        world of technology, design, and business. Explore expert opinions,
        success stories, and industry news to stay ahead in the digital
        landscape.
      </p>
      <BlogsTestimonial />
      <Footer />
    </div>
  );
};

export default Services;
